import { observer } from "mobx-react-lite"
import { useState, useEffect } from "react"
import { APP_LOGO } from "../StApp"
import { MatchDetailsStore } from "../stores/MatchDetailsStore"
import { DateDetailProps } from "./DateDetailModal"
import { DateDetaisBox } from "./DateDetailsBox"
import Loader from "./Loader"

const modalStyle: React.CSSProperties = {
    backgroundColor: '#fff',
    borderRadius: '10px',
    width: '100vw',
    height: '600px',
    position: 'relative',
    overflow: 'scroll'
};

const MatchUserActionSheet = (props:{matchUid: string, store: MatchDetailsStore })=>{

    const store = props.store

    if(store.user == null )
     return <div style={modalStyle} ><Loader/></div>
    else{
        const data: DateDetailProps = {
            mainImgUrl: APP_LOGO,
            user: store.user,
            likeButton: false
        }
     return(<DateDetaisBox user={store.user} data={data} style={modalStyle} />)}

}

export default observer(MatchUserActionSheet)